<template>
	<div id="app">

		<router-view></router-view>

		<el-dialog align="center" :visible.sync="diagVisible" :fullscreen=true :show-close=false
			:close-on-press-escape=false :close-on-click-modal=false>
			<div slot="title" align="center">
				<h3>系统登录</h3>
			</div>

			<el-form :model="loginForm" ref="loginForm" style='width: 300px;'>
				<el-form-item size="medium" prop="username">
					<el-input name="username" required type="text" v-model="loginForm.username" placeholder="用户名">
						<svg-icon slot="prefix" icon-class="user" />
					</el-input>
				</el-form-item>
				<el-form-item size="medium" prop="password">
					<el-input name="password" required type="password" @keyup.enter.native="handleLogin"
						v-model="loginForm.password" placeholder="密码">
						<svg-icon slot="prefix" icon-class="password" />
					</el-input>
				</el-form-item>
				<el-button type="primary" style="width:100%;" :loading="loading"
					@click.native.prevent="handleLogin">登录</el-button>
			</el-form>
		</el-dialog>
		<el-dialog title="修改密码" :visible.sync="userOldPw" :close-on-click-modal=false :show-close=false>
			<P v-if="userOldPw" style="color:#ff0000;font-size: large; text-align: center; width:500px">
				您正在使用的是初始密码，您必须重新设置您的密码。
			</P>
			<br />
			<el-form ref="dataForm" :model="temp" :rules="rules" label-position="right" size="mini" label-width="150px"
				style='width: 500px;'>
				<el-form-item size="medium" label="旧密码" prop="old_pwd" required>
					<el-input v-model="temp.old_pwd" type="password"></el-input>
				</el-form-item>
				<el-form-item size="medium" label="">
					<!--el-tag style="color:#ff0000;">新密码至少8位字符</el-tag-->
				</el-form-item>
				<el-form-item size="medium" label="新密码" prop="pwd" required>
					<el-input v-model="temp.pwd" type="password"></el-input>
				</el-form-item>
				<el-form-item size="medium" label="再次输入新密码" prop="pwd1" required>
					<el-input v-model="temp.pwd1" type="password"></el-input>
				</el-form-item>
				<el-form-item size="person_name" label="姓名" prop="person_name" required>
					<el-input v-model="temp.person_name"></el-input>
				</el-form-item>
				<el-form-item size="medium" label="手机号" prop="mobile" required>
					<el-input v-model="temp.mobile"></el-input>
				</el-form-item>
			</el-form>

			<div slot="footer" class="dialog-footer">

				<el-button type="primary" @click="updatePwd">确定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import sys_dic_api from '@/api/sys_dic'
import { getPcVersion } from '@/api/sys_version'
import { mapActions, mapGetters } from 'vuex'
import toTree from '@/utils/to_tree'
import sys_user_api from '@/api/sys_user'
// import { getVersionFile } from '@/api/getVersionFile'
import { getIsOlePwd, removeIsOlePwd, setServerTime } from '@/utils/auth'
import Cookies from 'js-cookie'
import axios from 'axios'

import { getSuccourTypeTreatmentStandardSubsidySetup } from '@/api/treatment_standard'

export default {
	name: 'App',
	created() {
		window.vm = this

		// // this.$route.path)

		// this.userOldPw = getIsOlePwd() == "1"
		// this.getMyDistrictTree()
		// this.getVersionFile()
		this.upgradeStart()
	},
	computed: {
		...mapGetters([
			'userName',
			'loginName',
			'level',
			'state',
			'state_name',
			'county',
			'county_name',
			'town',
			'town_name',
			'state_id',
			'status'
		])
	},
	data() {
		return {
			version_num: "",
			upgradeMsgboxIsShow: false,
			userOldPw: false,
			loginForm: {
				username: '',
				password: ''
			},
			diagVisible: false,
			loading: false,
			temp: {
				old_pwd: null,
				old_pwd: null,
				person_name: null,
				mobile: null,
			},
			rules: {
				pwd: [
					{ required: true, message: '请输入新密码', trigger: 'blur' },
					{ pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[\s\S]{8,}$/, message: '密码不得少于8个字符，且须包含大写字母、小写字母、数字', trigger: 'blur' }
				],
				pwd1: [
					{ required: true, message: '再次输入新密码', trigger: 'blur' },
					{ pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[\s\S]{8,}$/, message: '密码不得少于8个字符，且须包含大写字母、小写字母、数字', trigger: 'blur' }
				],
				person_name: [
					{ required: true, message: '姓名不能为空', trigger: 'blur' },

				],
				mobile: [
					{ pattern: /^1[3-9][0-9]{9}$/, message: '手机号格式错误', trigger: 'blur' }

				]
			}
		}
	},
	methods: {
		...mapActions([
			'setSysDic',
			'setMyDistrictTree',
			'setMyDistrictTreeCounty'
		]),
		isWeChatBrowser() {
			return /MicroMessenger/i.test(navigator.userAgent);
		},
		get_dic() {
			sys_dic_api.list({ type_exclude1: '行政区划', del_flag: '_all_' }).then(response => {
				if (response.data.success) {
					const tmp_data = []
					for (let i = 0; i < response.data.data.length; i++) {
						tmp_data[response.data.data[i].type] = response.data.data[i].children
					}

					sys_dic_api.getProviderOrg().then(response => {
						if (response.data.success) {
							tmp_data['供养机构'] = response.data.data
						}
					})
					this.setSysDic(tmp_data)
				}
			})
		},
		handleLogin() {
			this.$refs.loginForm.validate(valid => {
				if (valid) {
					this.loading = true
					this.$store.dispatch('LoginByUsername', this.loginForm).then(() => {
						// this.loginForm.username = ''
						this.loginForm.password = ''
						this.loading = false
						this.diagVisible = false
						// this.$router.push({ path: '/' })
					}).catch((response) => {
						this.$notify({ title: '失败', message: '登录失败:' + response.data.remark, type: 'error' })
						// this.loginForm.username = ''
						this.loginForm.password = ''
						this.loading = false
					})
				} else {
					return false
				}
			})
		},
		getMyDistrictTree() {
			const tmpData = Object.assign({}, this.treeQuery)
			tmpData.name = null
			tmpData.type = '行政区划'
			if (this.level === 1) {
				tmpData.pid = 650000
			} else if (this.level === 2) {
				tmpData.pid = this.state
			} else if (this.level === 3) {
				tmpData.pid = this.county
			} else if (this.level === 4) {
				tmpData.pid = this.town
			}

			tmpData._deep_ = 6
			sys_dic_api.list_tree(tmpData).then(response => {
				let tmpRESData = []
				if (this.level === 1) {
					tmpRESData = response.data.data
				} else if (this.level === 2) {
					tmpRESData[0] = {
						value: this.state,
						name: this.state_name,
						del_flag: '否',
						leaf: '否',
						id: this.state,
						children: response.data.data
					}
				} else if (this.level === 3) {
					const tmpRESchildrenData = [{
						value: this.county,
						name: this.county_name,
						del_flag: '否',
						leaf: '否',
						id: this.county, children: response.data.data
					}]
					tmpRESData[0] = {
						value: this.state,
						name: this.state_name,
						del_flag: '否',
						leaf: '否',
						id: this.state,
						children: tmpRESchildrenData

					}
				} else if (this.level === 4) {
					const tmpRESchildrenData1 = [{
						value: this.town,
						name: this.town_name,
						del_flag: '否',
						leaf: '否',
						id: this.town, children: response.data.data
					}]
					const tmpRESchildrenData = [{
						value: this.county,
						name: this.county_name,
						del_flag: '否',
						leaf: '否',
						id: this.county, children: tmpRESchildrenData1
					}]
					tmpRESData[0] = {
						value: this.state,
						name: this.state_name,
						del_flag: '否',
						leaf: '否',
						id: this.state,
						children: tmpRESchildrenData

					}
				}
				this.setMyDistrictTree(tmpRESData)
			})
		},
		getMyDistrictCountyTree() {
			const tmpData = Object.assign({}, this.treeQuery)
			tmpData.name = null
			tmpData.type = '行政区划'
			if (this.level === 1) {
				tmpData.pid = 650000
			} else if (this.level === 2) {
				tmpData.pid = this.state
			} else if (this.level === 3) {
				tmpData.pid = this.county
			} else if (this.level === 4) {
				tmpData.pid = this.town
			}

			tmpData._deep_ = 2
			sys_dic_api.list_tree(tmpData).then(response => {
				let tmpRESData = []
				if (this.level === 1) {
					tmpRESData = response.data.data
				} else if (this.level === 2) {
					tmpRESData[0] = {
						value: this.state,
						name: this.state_name,
						del_flag: '否',
						leaf: '否',
						id: this.state,
						children: response.data.data
					}
				} else if (this.level === 3) {
					const tmpRESchildrenData = [{
						value: this.county,
						name: this.county_name,
						del_flag: '否',
						leaf: '否',
						id: this.county, children: response.data.data
					}]
					tmpRESData[0] = {
						value: this.state,
						name: this.state_name,
						del_flag: '否',
						leaf: '否',
						id: this.state,
						children: tmpRESchildrenData

					}
				} else if (this.level === 4) {
					const tmpRESchildrenData1 = [{
						value: this.town,
						name: this.town_name,
						del_flag: '否',
						leaf: '否',
						id: this.town, children: response.data.data
					}]
					const tmpRESchildrenData = [{
						value: this.county,
						name: this.county_name,
						del_flag: '否',
						leaf: '否',
						id: this.county, children: tmpRESchildrenData1
					}]
					tmpRESData[0] = {
						value: this.state,
						name: this.state_name,
						del_flag: '否',
						leaf: '否',
						id: this.state,
						children: tmpRESchildrenData

					}
				}
				this.setMyDistrictTreeCounty(tmpRESData)
			})
		},
		updatePwd() {
			this.$refs['dataForm'].validate((valid) => {
				if (valid) {
					if (this.temp.pwd != this.temp.pwd1) {
						this.$notify({ title: '失败', message: '两次输入的新密码不一致', type: 'error', duration: 3000 })
						return
					}
					if (this.temp.old_pwd === this.temp.pwd1) {
						this.$notify({ title: '失败', message: '新密码不能与旧密码相同。', type: 'error', duration: 3000 })
						return
					}
					if (this.loginName.includes("admin")) {
						this.temp.person_name = this.temp.person_name
					} else if (this.loginName.includes("-c")) {
						if (!this.temp.person_name.includes("(村级)")) {
							this.temp.person_name = this.temp.person_name + "(村级)"
						}
					} else if (this.loginName.length > 8 && !this.loginName.includes("-c")) {
						if (!this.temp.person_name.includes("(乡镇级)")) {
							this.temp.person_name = this.temp.person_name + "(乡镇级)"
						}
					} else if (this.loginName.slice(2, 4) != '00' && this.loginName.slice(4, 6) != '00') {
						if (!this.temp.person_name.includes("(县级)")) {
							this.temp.person_name = this.temp.person_name + "(县级)"
						}
					} else if (this.loginName.slice(2, 4) != '00' && this.loginName.slice(4, 6) == '00') {
						if (!this.temp.person_name.includes("(地市级)")) {
							this.temp.person_name = this.temp.person_name + "(地市级)"
						}
					} else {
						if (!this.temp.person_name.includes("(自治区级)")) {
							this.temp.person_name = this.temp.person_name + "(自治区级)"
						}
					}
					sys_user_api.updatePwd(this.temp).then((resp) => {
						if (resp.data && resp.data.success) {
							// this.list.unshift(this.temp)
							// this.pwdUpdated = false;
							// this.showUpdatePwdDiag = false;
							// this.$store.state.user.pwdUpdated = "是";
							// this.$notify({title: '成功',message: '修改成功',type: 'success',duration: 2000})
							this.$confirm('密码修改成功，请使用新密码重新登录系统', '提示', { showCancelButton: false, closeOnClickModal: false, closeOnPressEscape: false, showClose: false, confirmButtonText: '确定' }).then(() => {
								this.logout()
							}).catch(() => {

							})
						} else if (resp.data && !resp.data.success) {
							this.$notify({ title: '失败', message: '修改失败:' + resp.data.remark, type: 'error', duration: 3000 })
						}
					})
				}
			})
		},
		logout() {
			this.$store.dispatch('FedLogOut').then(() => {
				Cookies.set('activeMenu', 0)
				removeIsOlePwd()
				location.reload()// In order to re-instantiate the vue-router object to avoid bugs
			})
		},
		upgradeStart() {
			let the = this


			var timer = setInterval(function () {
				// the.getVersionFile()

			}, (1000 * 60) * 5);
		},
		getVersionFile() {
			let the = this
			getPcVersion().then(responsew => {
				if (responsew.data.success) {
					if (responsew.data.data.list.length > 0) {
						let server_time = responsew.data.data.list[0]['now']
						let st_array = server_time.split("T")
						let t = st_array[1].split(".")
						setServerTime(st_array[0] + " " + t[0])
					}

					axios.get("https://shjz.mzt.xinjiang.gov.cn/mzjz-admin/version?t="+new Date().getTime()).then(requests => {
						if (this.version_num == "") {
							this.version_num = request.data.version
							return
						} else if (this.version_num == request.data.version) {
							return
						} else if (this.version_num !== request.data.version) {
							if (!the.upgradeMsgboxIsShow) {
								// "打开升级提示")
								the.upgradeMsgboxIsShow = true
								const h = the.$createElement;
								the.$msgbox({
									title: '升级提示',
									showClose: false,
									showCancelButton: false,
									closeOnClickModal: false,
									message: h('p', null, [
										h('span', null, '系统检测到有新的版本('),
										h('span', { style: 'color: teal' }, request.data.version),
										h('span', null, ')'),
										h('p', null, '是否立即升级？'),
										h('p', { style: 'color: red' }, "* 升级系统需要刷新页面，工作完成后请手动刷新页面。"),
									]),
									showCancelButton: true,
									confirmButtonText: '立即升级',
									beforeClose: (action, instance, done) => {
										if (action === 'confirm') {
											instance.confirmButtonLoading = true;
											instance.confirmButtonText = '执行中...';
											setTimeout(() => {
												done();
												setTimeout(() => {
													instance.confirmButtonLoading = false;
													the.upgradeMsgboxIsShow = false
													window.location.reload();
												}, 300);
											}, 3000);
										} else {
											the.upgradeMsgboxIsShow = false
											//"暂不升级")
											done();
										}
									}
								})
							} else {
								return
							}
						}
					}).catch(request => {
						return
					})
				}
			})
			axios.get("https://shjz.mzt.xinjiang.gov.cn/mzjz-admin/version?t="+new Date().getTime()).then(request => {
				if (this.version_num == "") {
					this.version_num = request.data.version
					return
				} else if (this.version_num == request.data.version) {
					return
				} else if (this.version_num !== request.data.version) {
					if (!the.upgradeMsgboxIsShow) {
						//"打开升级提示")
						the.upgradeMsgboxIsShow = true
						const h = the.$createElement;
						the.$msgbox({
							title: '升级提示',
							showClose: false,
							showCancelButton: false,
							closeOnClickModal: false,
							message: h('p', null, [
								h('span', null, '系统检测到有新的版本('),
								h('span', { style: 'color: teal' }, request.data.version),
								h('span', null, ')'),
								h('p', null, '是否立即升级？'),
								h('p', { style: 'color: red' }, "* 升级系统需要刷新页面，工作完成后请手动刷新页面。"),
							]),
							showCancelButton: true,
							confirmButtonText: '立即升级',
							beforeClose: (action, instance, done) => {
								if (action === 'confirm') {
									instance.confirmButtonLoading = true;
									instance.confirmButtonText = '执行中...';
									setTimeout(() => {
										done();
										setTimeout(() => {
											instance.confirmButtonLoading = false;
											the.upgradeMsgboxIsShow = false
											window.location.reload();
										}, 300);
									}, 3000);
								} else {
									the.upgradeMsgboxIsShow = false
									//"暂不升级")
									done();
								}
							}
						})
					} else {
						return
					}
				}
			}).catch(request => {
				return
			})
		}
	},
	// 侦听器
	watch: {
		userName(newName, oldName) {
			if (newName) {
				this.userOldPw = getIsOlePwd == "1"
				this.get_dic()
				this.getMyDistrictTree()
				this.getMyDistrictCountyTree()
			}
		},
		'$route'(to, from) { //监听路由是否变化
			if (this.isWeChatBrowser()) {
				//'您正在使用微信浏览器');
				this.$router.push('/is_wechat_open');
				return
			} else {
				//'您不是在微信浏览器中浏览');
			}
			if (to.path != "/loginPage") { //跳转到哪个页面
				// location.reload()
				this.userOldPw = getIsOlePwd() == "1"
			}
		},
	}
}
</script>
<style></style>



// WEBPACK FOOTER //
// src/App.vue